import { useCallback, useEffect, useState } from 'react';
import { isAbsoluteEmpty } from 'ziphy-web-shared/basic/helpers';
const useStates = ({ minDate, maxDate, defaultDate, isFull, defaultDateComponents, }) => {
    const [year, setYear] = useState();
    const [month, setMonth] = useState();
    const [day, setDay] = useState();
    useEffect(() => {
        const defaultTime = new Date(defaultDate).getTime();
        const minTime = minDate.getTime();
        const maxTime = maxDate.getTime();
        if (defaultTime > maxTime) {
            updateDates(maxDate);
        }
        else if (defaultTime < minTime) {
            updateDates(minDate);
        }
        else if (defaultDateComponents) {
            setYear(Number(defaultDateComponents.year));
            if (!isAbsoluteEmpty(defaultDateComponents.month)) {
                setMonth(Number(defaultDateComponents.month) - 1);
                if (!isAbsoluteEmpty(defaultDateComponents.day)) {
                    setDay(Number(defaultDateComponents.day));
                }
            }
        }
        else {
            updateDates(defaultDate);
        }
    }, [minDate, maxDate, defaultDate]);
    const updateDates = useCallback((date) => {
        setYear(date.getFullYear());
        if (isFull) {
            setMonth(date.getMonth());
            setDay(date.getDate());
        }
    }, []);
    return {
        year,
        month,
        day,
        setYear,
        setMonth,
        setDay,
    };
};
export default useStates;
